import React from "react";
import { pnpLogo } from "../Asserts";
import { useNavigate } from "react-router";
import useDeviceType from "../../_V2/Utiles/FindDevice";


export default function Header() {
  const navigate = useNavigate();
  const deviceType = useDeviceType();

  let logoClass = "object-contain";
  if (deviceType === "mobile") {
    logoClass = "h-14 object-contain";
  } else if (deviceType === "tablet") {
    logoClass = "w-[110px] h-[45px] object-contain";
  } else if (deviceType === "laptop") {
    // logoClass = "w-[130px] h-[60px] object-contain";
    logoClass = "w-[140px] h-[80px] laptop-banner:w-[165px] laptop-banner:h-[70px] object-contain";
  } else {
    logoClass = "w-[145px] h-[70px] object-contain";
  }

  return (
    <nav
      className="relative z-10 w-full bg-transparent shadow-sm"
    >
      <div className="flex justify-between items-center w-[95%] mx-auto md:gap-8 pr-2 md:pr-0">
        <div className="flex-shrink-0">
          <a href="">
            <img
              src={pnpLogo}
              className={`w-[100px] md:w-[130px] lg:w-[160px] xl:w-[220px] 2xl:w-[250px]`}
              alt="logo"
            />
          </a>
        </div>
        <div className="laptop-banner:text-[15px] text-[12px] font-[400] font-roboto flex laptop-banner:gap-5 gap-1 items-center flex-shrink-0">
          <button
            className="bg-[#00C05B] 2xl:text-[24px] text-[10px] sm:text-[11px] md:text-[16px] 2xl:py-[8px] py-[7px] 2xl:px-[20px] px-4 sm:px-[1.5rem] rounded-[30px] text-white font-medium whitespace-nowrap"
            onClick={() => {
              sessionStorage.setItem("landingVisited", "true");
              navigate("/login")
            }}
          >
            Login
          </button>

          <button
            className="bg-[#007FFF] 2xl:text-[24px] text-[10px] sm:text-[11px] md:text-[16px] 2xl:py-[8px] py-[7px] 2xl:px-[20px] px-2 sm:px-[1rem] md:px-[1.15rem] rounded-[30px] text-white font-medium whitespace-nowrap"
            onClick={() => {
              sessionStorage.setItem("landingVisited", "true");
              navigate("/signup");
            }}
          >
            Sign Up For Free
          </button>
        </div>
      </div>
    </nav>
  );
}
